var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Form',{attrs:{"data-detail":_vm.dataDetail,"action":"detail"}})}
var staticRenderFns = []

export { render, staticRenderFns }